<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MgXMI8/tc-custom/9781479802777.jpg?1728259236069" alt="This image is the cover for the book Evolution of the Juvenile Court, Youth, Crime, and Justice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evolution of the Juvenile Court, Youth, Crime, and Justice
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Winner, 2020 ACJS Outstanding Book Award, given by the Academy of Criminal Justice Sciences</i></b><br/><b><br/>A major statement on the juvenile justice system by one of America’s leading experts</b><br/><br/>The juvenile court lies at the intersection of youth policy and crime policy. Its institutional practices reflect our changing ideas about children and crime control.  The Evolution of the Juvenile Court provides a sweeping overview of the American juvenile justice system’s development and change over the past century. Noted law professor and criminologist Barry C. Feld places special emphasis on changes over the last 25 years—the ascendance of get tough crime policies and the more recent Supreme Court recognition that “children are different.”<br/><br/>Feld’s comprehensive historical analyses trace juvenile courts’ evolution though four periods—the original Progressive Era, the Due Process Revolution in the 1960s, the Get Tough Era of the 1980s and 1990s, and today’s Kids Are Different era. In each period, changes in the economy, cities, families, race and ethnicity, and politics have shaped juvenile courts’ policies and practices.  Changes in juvenile courts’ ends and means—substance and procedure—reflect shifting notions of children’s culpability and competence.<br/><br/>The Evolution of the Juvenile Court examines how conservative politicians used coded racial appeals to advocate get tough policies that equated children with adults and more recent Supreme Court decisions that draw on developmental psychology and neuroscience research to bolster its conclusions about youths’ reduced criminal responsibility and diminished competence. Feld draws on lessons from the past to envision a new, developmentally appropriate justice system for children. Ultimately, providing justice for children requires structural changes to reduce social and economic inequality—concentrated poverty in segregated urban areas—that disproportionately expose children of color to juvenile courts’ punitive policies.<br/><br/>Historical, prescriptive, and analytical, The Evolution of the Juvenile Court evaluates the author’s past recommendations to abolish juvenile courts in light of this new evidence, and concludes that separate, but reformed, juvenile courts are necessary to protect children who commit crimes and facilitate their successful transition to adulthood.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barry Feld
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38c21230